import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Memecoin } from '../../../../../types/reducerTypes'
import usePoolTransactionsByAddress from '../../usePoolTransactionsByAddress'
import {
  channels,
  useWebSocketContext,
} from '../../../../../contexts/WebSocketContext'
import { insertTransaction } from '../../../../../modules/memecoins/slice'
import { usePagination } from '../../../../../hooks/usePagination'
import PureTradesTable from '../PureTradesTable'
import { KIRA_ADDRESS } from '../..'
import { Box } from '../../../../../shared_components/UI/Box'
import AnimatedLoader from '../../../../../shared_components/AnimatedLoader'
import { useSimpleLoadMorePagination } from '../../../../../hooks/useSimpleLoadMorePagination'
import { ThemedButton } from '../../../../../shared_components/ThemedButton'

export const KIRA_TRANSACTION =
{
  "_id": "66c5d0c004df26fa1ad64b7a",
  "timestamp": "2024-10-03T06:41:09.784Z",
  "event": "Purchase",
  "contractAddress": "0xd1841F04f5653e524AC35b8D455d7891fc6aB9e4",
  "transactionHash": "0xbb8bfbb6988b7353c781528f4e78bd8222f503486669d4cc3c136b326e82ee8e",
  "walletAddress": "0x409F6DE7e86206A14D2432B434447a57BdFdc8FD",
  "amount": "",
  "meta": {
    "amountIn": "2040200000000000000",
    "amountOut": "124547364464865",
    "_id": "66fe57ade721108d1d2c8cf9"
  },
  "chainId": "8453",
  "nansenScore": 0
}

function AllTradesTable({ memecoin }: { memecoin: Memecoin }) {
  const poolAddress = memecoin.poolAddress
  const ordering = 'desc'

  const isKira = poolAddress === KIRA_ADDRESS

  // const { limit, offset, onNext, onPrev, goToPage } = usePagination({
  //   defaultLimit: 20,
  // })

  const { onLoadMore, limit, offset } = useSimpleLoadMorePagination({ defaultLimit: 20 })
  
  const { transactions, meta, isLoading, isFetching } = usePoolTransactionsByAddress(
    memecoin.poolAddress,
    ordering,
    limit,
    offset,
  )


  const dispatch = useDispatch()
  const { subscribe, unsubscribe } = useWebSocketContext()

  useEffect(() => {
    const channel = channels.poolTransactionsByAddress(poolAddress)

    subscribe('all-trades-table', channel, (message) => {
      dispatch(
        insertTransaction({
          transaction: message.data,
          // cacheKey: cacheKey0, // 0 offset to insert on first cache list
        }),
      )
    })

    return () => {
      unsubscribe('all-trades-table', channel)
    }
  }, [
    // cacheKey0,
    dispatch,
    limit,
    ordering,
    poolAddress,
    subscribe,
    unsubscribe,
  ])
  const transactionsToPass = isKira ? [KIRA_TRANSACTION, ...transactions] : transactions

  if (isLoading) {
    return (
      <Box ac jc alignSelf='center'>
        <AnimatedLoader onlyWhite size={32} />
      </Box>
    )
  }

  const showPagination = transactionsToPass.length < meta?.total
  
  return (
    <PureTradesTable
      memecoin={memecoin}
      transactions={transactionsToPass}
      pagination={showPagination &&
        <ThemedButton $styleType='tertiary' onClick={onLoadMore} disabled={isFetching} w='124.4px'>
          {isFetching
            ? <Box ac jc alignSelf='center'>
                <AnimatedLoader onlyWhite size={24} />
              </Box>
            : 'Load More ...'}
        </ThemedButton>
      }
    />
  )
}

export default AllTradesTable
